// src/layouts/LayoutMobile.jsx
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import Sidebar from "../components/Sidebar/Sidebar";
import MobileHeader from "../components/MobileHeader/MobileHeader";
import BottomBar from "../components/BottomBar/BottomBar";

import { useAuth } from "../contexts/AuthContext";
import { useEmpresa } from "../contexts/EmpresaContext";
import { NIVEIS } from "../config/niveis";

function LayoutMobile({
  tema,
  alterarTema,
  titulo,
  sidebarAberta,
  onToggleSidebar,
  abaBottom = "home",
  children,
}) {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const { empresaAtual } = useEmpresa();

  const flags = useMemo(() => {
    const nivel = Number(usuario?.nivel ?? -1);
    return {
      isKiosk: nivel === NIVEIS.KIOSK,
      isCliente: nivel === NIVEIS.CLIENTE,
    };
  }, [usuario]);

  const logoUrl = empresaAtual?.logoUrl || null;

  return (
    <div className={`app-root ${tema}`}>
      {!flags.isKiosk && (
        <Sidebar isOpen={sidebarAberta} onClose={onToggleSidebar} isMobile={true} />
      )}

      <div className="app-shell-mobile">
        <MobileHeader
          tema={tema}
          alterarTema={alterarTema}
          onToggleSidebar={onToggleSidebar}
          titulo={titulo}
          isKiosk={flags.isKiosk}
          logoUrl={logoUrl}
        />

        <main className="m-main">{children}</main>

        <BottomBar
          usuario={usuario}
          abaAtiva={abaBottom}
          onNavigate={(rota) => navigate(rota)}
        />
      </div>
    </div>
  );
}

export default LayoutMobile;
